import type { Connector } from './getConnector';

const connectorLookupCache = new Map<string, Connector>();

export function getOrComputeConnectorLookup(
  id: string,
  compute: () => Connector
): Connector {
  if (connectorLookupCache.has(id)) {
    const cached = connectorLookupCache.get(id);
    if (cached) {
      return cached;
    }
  }
  const result = compute();
  connectorLookupCache.set(id, result);
  return result;
}

/** Call when connector lists change so lookups reflect new jsonSchema / metadata. */
export function clearGetConnectorLookupCache() {
  connectorLookupCache.clear();
}
